import { render, staticRenderFns } from "./MobileLanguageSelector.vue?vue&type=template&id=161928e6&scoped=true&"
import script from "./MobileLanguageSelector.vue?vue&type=script&lang=js&"
export * from "./MobileLanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./MobileLanguageSelector.vue?vue&type=style&index=0&id=161928e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161928e6",
  null
  
)

export default component.exports